import moment from 'moment'
import _ from 'lodash'

// constants
export const SERVER_API_URL = process.env.VUE_APP_SERVER_API_URL
export const passedFailedTitle = 'Pass/Fail Log'
export const timeSpentTitle = 'Time Spent Log'
export const interactionTitle = 'Interaction Log'
export const timelineTitle = 'Timeline Log'
export const questionTitle = 'Question Log'
export const completionTitle = 'Completion Log'
export const completionNotAttemptedTitle = 'Not Attempted Log'

export const TOTAL_ITEMS = 7

export const pieChartStyle = {
  margin: 'auto',
  height: '28vh',
  width: '80%',
  position: 'relative'
}

export const passedFailedTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'name' },
  { text: 'Verb', align: 'start', sortable: true, value: 'verb' },
  {
    text: 'Definition Name',
    align: 'start',
    sortable: true,
    value: 'definitionName'
  },
  { text: 'Score', align: 'start', sortable: true, value: 'score' },
  { text: 'Duration', align: 'start', value: 'duration' },
  { text: 'Timestamp', align: 'start', sortable: true, value: 'timestamp' }
]

export const interactionTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'name' },
  { text: 'Verb', align: 'start', sortable: true, value: 'verb' },
  { text: 'Activity', align: 'start', sortable: true, value: 'definitionName' },
  { text: 'Duration', align: 'start', value: 'duration' },
  { text: 'Timestamp', align: 'start', sortable: true, value: 'timestamp' }
]

export const timeSpentTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'name' },
  { text: 'Activity', align: 'start', sortable: true, value: 'definitionName' },
  { text: 'Duration', align: 'start', value: 'duration' },
  { text: 'Timestamp', align: 'start', sortable: true, value: 'timestamp' }
]

export const interactionDetailTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'name', width: '15%' },
  { text: 'Verb', align: 'start', sortable: true, value: 'verb', width: '7%' },
  {
    text: 'Definition',
    align: 'start',
    sortable: true,
    value: 'definitionName',
    width: '17%'
  },
  {
    text: 'Device Type',
    align: 'start',
    sortable: false,
    value: 'deviceType',
    width: '10%'
  },
  {
    text: 'Scene',
    align: 'start',
    sortable: true,
    value: 'section',
    width: '10%'
  },
  {
    text: 'Score',
    align: 'start',
    sortable: false,
    value: 'score',
    width: '5%'
  },
  {
    text: 'Response',
    align: 'start',
    sortable: false,
    value: 'userResponse',
    width: '8%'
  },
  {
    text: 'Result',
    align: 'start',
    sortable: false,
    value: 'response',
    width: '5%'
  },
  {
    text: 'Duration',
    align: 'start',
    sortable: false,
    value: 'duration',
    width: '5%'
  },
  {
    text: 'Timestamp',
    align: 'center',
    sortable: true,
    value: 'timestamp',
    width: '18%'
  }
]

export const questionTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'name' },
  { text: 'Verb', align: 'start', sortable: true, value: 'verb' },
  { text: 'Activity', align: 'start', sortable: true, value: 'definitionName' },
  { text: 'Response', align: 'start', sortable: true, value: 'userResponse' },
  { text: 'Result', align: 'start', sortable: true, value: 'response' },
  { text: 'Duration', align: 'start', value: 'duration' },
  { text: 'Timestamp', align: 'start', sortable: true, value: 'timestamp' }
]

export const completionTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'name' },
  { text: 'Verb', align: 'start', sortable: true, value: 'verb' },
  { text: 'Activity', align: 'start', sortable: true, value: 'definitionName' },
  { text: 'Score', align: 'start', sortable: true, value: 'score' },
  { text: 'Duration', align: 'start', value: 'duration' },
  { text: 'Timestamp', align: 'start', sortable: true, value: 'timestamp' }
]

export const completionNotAtteptedTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'name' }
]

export const variablesTableHeader = [
  { text: 'Name', align: 'start', sortable: true, value: 'user' }
]

export const defaultColors = [
  // '#1664BF', // logo color
  // '#00ABE7', // light blue
  // '#EABA6B', // orange
  // '#CBE896', // bright green
  // '#75B9BE', // dusty blue
  // '#9191E9', // bright purple
  // '#2D5D7B', // dark dusty blue
  // '#49306B', // plum
  // '#635380', // dusty purple
  // '#F25F5C', // bright light red
  // '#70C1B3', // gray
  // '#FFE066', // yellow gold
  // '#DBD3AD', // dusty green
  // '#F24236', // red
  // '#FE5D26', // bright orange
  // '#065143', // dark green
  // '#70B77E', // dark mint
  // '#0E4749', // teal
  // '#70C1B3', // Mint
  // '#DA627D', // Pink
  // '#CA2E55'  // Bright Pink

  '#337CA0', // muted blue
  '#75B9BE', // dusty blue
  '#FFDDA1', // beige
  '#061A40', // navy
  '#B9D6F2', // cornflower blue
  '#D00000', // bright red
  '#028090', // teal
  '#114B5F', // dark teal
  '#00A6A6', // light teal
  '#49306B', // plum
  '#393E41', // gray
  '#8ACB88', // mint
  '#720026', // dark pink
  '#33A000', // green
  '#534B62', // dark purple
  '#EABA6B' // orange
]

// functions
export function getDateOptionsFromInteractions(interactions) {
  let min,
    max = null
  const dates = []

  interactions.forEach(element => {
    if (max == null) {
      max = element.timestamp
    } else if (moment(element.timestamp).isAfter(moment(max))) {
      max = element.timestamp
    }

    if (min == null) {
      min = element.timestamp
    } else if (moment(min).isAfter(moment(element.timestamp))) {
      min = element.timestamp
    }
  })

  let yearsDiff = moment(max).diff(moment(min), 'years')
  let monthsDiff = moment(max).diff(moment(min), 'months')
  let daysDiff = moment(max).diff(moment(min), 'days')
  let hoursDiff = moment(max).diff(moment(min), 'hours')

  const currentDate = moment()
  max = moment(max)
  min = moment(min)

  let offSet = currentDate.diff(max, 'days')
  let needHours = true
  // add 30 days first
  if (daysDiff >= 30 && offSet < 30) {
    needHours = false
    let start = currentDate.clone()
    let end = currentDate.clone()
    dates.push({
      start: start.subtract(30, 'days').format('LL'),
      end: end,
      format: 'days',
      name: 'last 30 days'
    })
  }

  offSet = currentDate.diff(max, 'months')
  if (daysDiff >= 31 && offSet <= 6) {
    needHours = false
    //const months = monthsDiff >= 6 ? 6 : monthsDiff
    let start = currentDate.clone()
    let end = currentDate.clone()
    dates.push({
      start: moment(start).subtract(6, 'months'),
      end: end,
      format: 'months',
      name: 'past 6 months'
    })
  }

  // if (monthsDiff >= 6) {
  //   needHours = false
  //   const startDate = min.clone()
  //   const endDate = currentDate.clone()
  //   while (max.diff(min, 'years') >= 0) {
  //     dates.push({
  //       start: startDate,
  //       end: endDate,
  //       format: 'years',
  //       name: min.format('YYYY')
  //     })
  //     startDate.add(1, 'year')
  //   }
  // }

  if (needHours && offSet == 0) {
    const startDate = min.clone()
    const endDate = max.clone()
    dates.push({
      start: startDate.subtract(1, 'hours'),
      end: endDate.add(1, 'hours'),
      format: 'hours',
      name: 'last 30 days'
    })
  }

  if (yearsDiff >= 0) {
    let years = []
    let now = min.clone().startOf('year')
    let end = max.clone()
    end = end.endOf('year')

    while (now.isSameOrBefore(end)) {
      let endOfYear = now.clone().endOf('year')
      let sartOfYear = now.clone().startOf('year')
      years.push({
        start: sartOfYear,
        end: endOfYear,
        format: 'years',
        name: now.format('YYYY')
      })
      now = now.add(1, 'years').startOf('year')
    }

    // only add years if there is multiple
    if (years.length > 1) {
      dates.push.apply(dates, years)
    }
  }

  const startDate = min.clone()
  const endDate = currentDate.clone()

  if (yearsDiff > 0) {
    dates.push({
      start: startDate,
      end: endDate,
      format: 'months',
      name: 'all'
    })
  } else if (monthsDiff > 0) {
    dates.push({
      start: startDate,
      end: endDate,
      format: 'months',
      name: 'all'
    })
  } else {
    dates.push({
      start: startDate,
      end: endDate,
      format: 'days',
      name: 'all'
    })
  }

  return dates
}

export function getLocalDate(timestamp) {
  return moment.utc(timestamp).local()
}

export function ellipsisLongText(str, maxChar) {
  if (str.length > maxChar) {
    let newText = str.substr(0, maxChar)
    return newText + '...'
  }
  return str
}

export function getRandomColor() {
  return '#' + Math.floor(Math.random() * 16777215).toString(16)
}

export function getRandomColorFromList(exclude) {
  let newColors = defaultColors
  if (exclude !== undefined && exclude != null) {
    newColors = _.filter(defaultColors, function(o) {
      return !exclude.includes(o)
    })
  }
  return newColors[Math.floor(Math.random() * newColors.length)]
}

export function getDuration(duration) {
  const d = moment.duration(duration)
  return moment.utc(d.as('milliseconds')).format('H:mm:ss')
}

export function roundToTwo(num) {
  return +(Math.round(num + 'e+2') + 'e-2')
}

export function sortDataByDate(logData) {
  logData = _.sortBy(logData, function(data) {
    return new Date(data.timestamp)
  })
  return logData
}

export function convertArrayOfObjectsToCSV(args) {
  let result, ctr, keys, columnDelimiter, lineDelimiter, data

  data = args.data || null
  if (data == null || !data.length) {
    return null
  }

  columnDelimiter = args.columnDelimiter || ','
  lineDelimiter = args.lineDelimiter || '\n'

  keys = Object.keys(data[0])

  result = ''
  result += keys.join(columnDelimiter)
  result += lineDelimiter

  data.forEach(function(item) {
    ctr = 0
    keys.forEach(function(key) {
      if (ctr > 0) {
        result += columnDelimiter
      }

      result += item[key]
      ctr++
    })
    result += lineDelimiter
  })

  return result
}

export function csvExport(headers, arrData, fileName) {
  let csvContent = convertArrayOfObjectsToCSV({
    data: arrData,
    keys: headers
  })

  if (csvContent == null) return

  fileName = fileName || 'export'

  const data = new Blob(['\ufeff', csvContent])
  const url = URL.createObjectURL(data)
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', fileName + '.csv')
  link.click()
}

export function getToken() {
  const token = localStorage.getItem('token')
  if (token != null && token !== undefined && token !== 'undefined') {
    return token
  }
  return null
}

export function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(location.search)
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export function capitalizeFirstLetter(string) {
  if (string != null && string !== undefined) {
    return string[0].toUpperCase() + string.slice(1)
  }
  return string
}

// classes
export class Multiset extends Map {
  constructor(...args) {
    super(...args)
  }
  add(elem) {
    if (!this.has(elem)) this.set(elem, 1)
    else this.set(elem, this.get(elem) + 1)
  }
  remove(elem) {
    var count = this.has(elem) ? this.get(elem) : 0
    if (count > 1) {
      this.set(elem, count - 1)
    } else if (count == 1) {
      this.delete(elem)
    } else if (count == 0)
      throw `tried to remove element ${elem} of type ${typeof elem} from Multiset, but does not exist in Multiset (count is 0 and cannot go negative)`
    // alternatively do nothing {}
  }
}
